import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import axios from "axios";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS

export default function AuthCallback() {
  const { API, setUser } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/"); return; }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        const r = await axios.post(`${API}/auth/google-session`,
          { session_id: sessionId }, { withCredentials: true });
        setUser(r.data.user);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [API, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F6F5F2]">
      <div className="font-heading text-lg">Signing you in…</div>
    </div>
  );
}
